export const CSRF_TOKEN_KEY = 'X-ZAMP-CSRF';
export const REQUEST_RESOURCE_TYPE = 'X-ZAMP-Requested-Resource-Type';
export const REQUEST_RESOURCE_TYPE_MERCHANT = 'merchant';
export const REQUEST_TIMEOUT = 80000;
